export const getCurrentDate = (): string => new Date().toLocaleString('ru-RU').split(',')[0];
